import { m, type MithrilVNode } from '../../mithril';
import type { MaterialIcon, MaterialSymbol } from './icons';

const ICON_FONT_CLASS = 'material-icons';
const SYMBOL_FONT_CLASS = 'material-symbols-outlined';

const CONST_CLASS_OBJ = { className: ICON_FONT_CLASS };
const CONST_SYMBOL_CLASS_OBJ = { className: SYMBOL_FONT_CLASS };

interface IconOptions {
	className?: string;
	[key: string]: unknown;
}

function viewInFont(
	fontClass: string,
	constClassObj: { className: string },
	icon: MaterialIcon | MaterialSymbol | MithrilVNode,
	opts?: IconOptions
) {
	if (opts == null) {
		return m('i', constClassObj, icon);
	}

	if (opts.className) {
		opts.className = opts.className + ' ' + fontClass;
	} else {
		opts.className = fontClass;
	}

	return m('i', opts, icon);
}

export function view(icon: MaterialIcon | MithrilVNode, opts?: IconOptions) {
	return viewInFont(ICON_FONT_CLASS, CONST_CLASS_OBJ, icon, opts);
}

export function symbol(icon: MaterialSymbol | MithrilVNode, opts?: IconOptions) {
	return viewInFont(SYMBOL_FONT_CLASS, CONST_SYMBOL_CLASS_OBJ, icon, opts);
}

export const Icon = { view, symbol };
